import React, {useEffect, useMemo, useState} from 'react'
import { useHistory } from 'react-router';

import FixedLoader from "../../../components/FixedLoader/FixedLoader";
import {TopBarRedesigned} from "../../../components/TopBarRedesigned";
import {
    Page,
    Title,
    ShiftBox,
    ButtonBox,
    StatusBox,
    ShiftBoxTime,
    ShiftBoxDate,
    TitleContainer,
    ContentContainer,
    SubtitleSecondary, StatusBoxPending,
} from "./ShiftDetail.styles";
import styles from "./ShiftDetail.module.scss";
import DateRangeOutlinedIcon from "@material-ui/icons/DateRangeOutlined";
import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";
import ScheduleOutlinedIcon from "@material-ui/icons/ScheduleOutlined";
import heartFilled from "../../../images/heartFilled.svg";
import heartUnfilled from "../../../images/heartUnfilled.svg";
import {Icon} from "../AvailableJobsPage/AvailableJobsPage.styles";
import TagFacesIcon from '@mui/icons-material/TagFaces';
import CableIcon from '@mui/icons-material/Cable';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import WavingHandIcon from "@mui/icons-material/WavingHand";
import CancellationLabel from "../../../components/CancellationLabel";
import { CancellationLabelWrapper } from './ShiftDetail.styles';
import { AdminTasksDisplay } from "../AvailableJobPage/components/AdminTasksDisplay";

import {
    convertDentalOfficeStatus,
    AccordionExpandIcon,
    DataPoint,
    CompleteShiftModal, DistanceComponent, ResubmitShiftModal, ShiftPopup, MapButton,
} from "./components";
import Api, {config} from "../../../api";
import {exitReact} from "../../../utils";
import _ from "lodash";
import useActionApi from "../../../hooks/useActionApi";
import {usePersistedState} from "../../../hooks";
import {HygienistProps} from "utils/types";
import {entities} from "../../../reduxStore";
import { JobProps } from "utils/types";
import Popup from "../../../components/Popup";
import clsx from "clsx";

dayjs.extend(isToday)

export const JOB_STATUSES = {
    POSTED: 1,
    PARTIAL: 2,
    CONFIRMED: 3,
    COMPLETED: 4,
    OFFER_EXPIRED: 5
}

export const PARTIAL_OFFER_STATUS = {
    POSTED: 0,
    REJECTED: 1,
    ACCEPTED: 2,
    EXPIRED: 3,
    REMOVED: 4
}

interface ShiftDetail {
}

export default function ShiftDetail({}: ShiftDetail) {
    const [trackData, setTrackData] = useState<any>(null);
    const history = useHistory();
    const {jobId, job: jobData, fromHome } = history.location.state as any
    const [job, setJob] = useState(jobData || {} as any)
    const [isFavouriteDentist, setFavouriteDentist] = useState<boolean>(jobData?.isFavouriteDentist || false)
    const [isOpenRemoveOfferModal, setIsOpenRemoveOfferModal] = useState<boolean>(false);

    const hygienist = usePersistedState<HygienistProps>({
        entityName: entities.hygienist
    })[0];

    const offer = useMemo(() => {
        if(!_.isEmpty(job))
            return _.findLast(job?.partialOffers, (offer: any) => offer.hygienistId === hygienist.id)
    }, [job]);

    const expiredOfferId = useMemo(() => {
        return job?.partialOffers?.find((offer: any) => offer.hygienistId === hygienist.id
            && offer.status === PARTIAL_OFFER_STATUS.EXPIRED)?.id
    }, [job])

    const removeOffer = async () => {
        setIsOpenRemoveOfferModal(true)
    }

    const isConfirmedJob = JOB_STATUSES.CONFIRMED === job.status;

    let menuItems: { value: string; onClick: (e: any) => void; }[] = [];

    if(JOB_STATUSES.PARTIAL === job.status
        || (JOB_STATUSES.OFFER_EXPIRED === job.status && expiredOfferId)) {
        menuItems = [{value: 'Remove Offer', onClick: removeOffer}]
    }

    const [getJobDetailsLoading, , getJobDetails] = useActionApi({
        apiMethod: Api.getJobDetails,
        onSuccess: (jobObj: any) => {
            if(_.isEmpty(jobObj)) return
            setJob(jobObj)
        },
    });

    const [checkFavouriteLocationLoading, , checkFavouriteLocation] = useActionApi({
        apiMethod: Api.checkFavouriteLocation,
        onSuccess: (data: any) => {
            setFavouriteDentist(data.isFavouriteDentist)
        },
    });

    const [removePartialOfferLoading, , removePartialOffer] = useActionApi({
        apiMethod: Api.removePartialOffer,
        onSuccess: () => {
            history.push('loading')
            ;(window as any).TempStars?.App?.goReact('hygienistHome')
        },
    });

    useEffect(() => {
        if(_.isEmpty(jobData) && jobId) {
            getJobDetails(jobId)
        }
    }, [])

    useEffect(() => {
        if (!_.isEmpty(job)) {
            setTrackData({
                isInstabookEnabled: !!job.Instabook,
                recommendedHourlyRate: job.proposedRate,
                currencyCode: job.location.country ? 'USD' : 'CAD',
                dentalOfficeLocationId: job.locationId,
                dentalOfficeId: job.dentistId,
                dentalOfficeStatus: convertDentalOfficeStatus(job.location.status),
                shiftStartDate: new Date(job.startDate.replace(/-/g, "/") + ' ' + job.shifts[0].postedStart).toISOString(),
                shiftEndDate: new Date(job.startDate.replace(/-/g, "/") + ' ' + job.shifts[0].postedEnd).toISOString(),
                shiftId: job.shifts[0].id,
                shiftPostDate: new Date(job.postedOn).toISOString(),
            })
            checkFavouriteLocation(job.locationId)
        }
    }, [job]);

    const title = isConfirmedJob ? 'Booked/Confirmed Shift' : 'Shift Details';
    const hourlyRate = `$${offer?.hourlyRate}/hr`;

    return (<>
        <TopBarRedesigned
            title={title}
                onBack={() => {
                    history.push('loading')
                    ;(window as any).TempStars?.App?.goReact('hygienistHome')
                }}
        />
        {!_.isEmpty(job) ? <Page>
            <TitleContainer>
                <Title>{job.location.practiceName}<Icon
                    style={{height: 22, cursor: 'default'}}
                    src={isFavouriteDentist ? heartFilled : heartUnfilled}
                /></Title>

                <ShiftBox>
                    <ShiftBoxDate>
                        <DateRangeOutlinedIcon className={styles.shiftDateIcon}/>
                        {dayjs(job.shifts[0].shiftDate).format('dddd MMM, D')}
                    </ShiftBoxDate>
                    <ShiftBoxTime>
                        <ScheduleOutlinedIcon className={styles.shiftDateIcon}/>
                        {`${job.shifts[0].postedStart} - ${job.shifts[0].postedEnd}`}
                    </ShiftBoxTime>
                </ShiftBox>

                {isConfirmedJob && !dayjs(job.startDate).isToday() ? <div className={styles.confirmedJobBox}>
                    <StatusBox>
                        <EventAvailableIcon className={styles.confirmedShiftIcon}/>
                        Confirmed
                    </StatusBox>
                    <b>{`Booked Rate: ${hourlyRate}`}</b>
                </div> : null}

                {JOB_STATUSES.PARTIAL === job.status ? <div className={styles.confirmedJobBox}>
                    <StatusBoxPending>
                        <WavingHandIcon className={styles.confirmedShiftIcon}/>
                        Offer Pending
                    </StatusBoxPending>
                    <b>{`Offer Rate: ${hourlyRate}`}</b>
                </div>: null}

                <Popup opened={isOpenRemoveOfferModal} onClose={() => setIsOpenRemoveOfferModal(false)}>
                    <ShiftPopup
                        job={job}
                        close={'Cancel'}
                        title={'Remove Offer?'}
                        submit={'Remove Offer'}
                        onSubmit={() => {removePartialOffer(offer?.id)}}
                        onClose={() => setIsOpenRemoveOfferModal(false)}
                    />
                </Popup>

                <CompleteShiftModal job={job} history={history} trackData={trackData} />

                <ResubmitShiftModal job={job} history={history} trackData={trackData} expiredOfferId={expiredOfferId} />

                <SubtitleSecondary style={{opacity: 1}}>
                    {isConfirmedJob ? `${job.location.address}, ` : ''}
                    {`${job.location.city}, ${job.location.province} ${job.location.postalCode}`}
                </SubtitleSecondary>

                {job?.reposted ? (
                    <CancellationLabelWrapper>
                        <CancellationLabel
                            startDate={job?.shifts?.[0]?.shiftDate}
                            postedStartTime={job?.shifts?.[0]?.postedStart}
                        />
                    </CancellationLabelWrapper>
                ) : null}

                {/*<DistanceComponent job={job} />*/}

                <ButtonBox>
                    <MapButton className={clsx(styles.removeCancelOfferButton, styles.mapBtn)} job={job}/>
                </ButtonBox>
            </TitleContainer>

            <ContentContainer style={{ margin: '1rem' }}>
                <DataPoint
                    isShow={job.location.friendlyEndorsed}
                    icon={<TagFacesIcon/>}
                    description={'Friendly team'}
                />
                <DataPoint
                    isShow={job.location.equipEndorsed}
                    icon={<CableIcon/>}
                    description={'Good equipment'}
                />
                <DataPoint
                    isShow={!!job.shifts[0].gapUnpaid}
                    icon={<CalendarTodayOutlinedIcon/>}
                    label={'Downtime'}
                    description={'Unpaid'}
                />
            </ContentContainer>

            {/* Reception/Admin duties + attire (T2-6509) */}
            {job.type === 2 && job.adminTasks && (
                <div style={{ margin: '0 1rem' }}>
                    <AdminTasksDisplay
                        adminTasks={job.adminTasks}
                        attire={job.adminTasks.attire}
                    />
                </div>
            )}

            <AccordionExpandIcon job={job} />

        </Page> : null}

        <FixedLoader
            loading={getJobDetailsLoading || checkFavouriteLocationLoading || removePartialOfferLoading}
        />
    </>)
}
